import type { PresentationIsEmptyProps } from '../../'
export default function isEmpty({ quote }: PresentationIsEmptyProps) {
  const hasContent = quote?.terms?.content && quote.terms.content.replace('<p></p>', '').trim()
  const isAccepted = quote?.status?.value === 'accepted'
  const hasSignature = !!quote?.signatures?.customer
  return !hasContent && !(isAccepted && hasSignature)
}
